import React from 'react';
import Number from './Number';
import { InputAdornment as MuiInputAdornment } from '@material-ui/core';
import styled from 'styled-components/macro';
import {
  currencies,
  defaultCurrency
} from '../../internal-components/form-builder/currencies';

export { currencies, defaultCurrency };

const InputAdornment = styled(MuiInputAdornment)`
  p {
    margin: 0 !important;
  }
`;
export default function Currency({ options, ...props }) {
  options = typeof options === 'string' ? options.split('\x01') : options;

  const { symbol } = currencies[options[0] || defaultCurrency];

  const startAdornment = React.useMemo(
    () => <InputAdornment position="start">{symbol}</InputAdornment>,
    [symbol]
  );

  return (
    <Number
      startAdornment={startAdornment}
      key={props.name + symbol}
      type="number"
      {...props}
    />
  );
}
